module.exports = __webpack_public_path__ + "static/img/hzhb_tp.d8800dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hzhb_tp.png
// module id = w7FR
// module chunks = 0